import { MenuItem } from '../models/menu-item.model';

export const mainMenu: MenuItem[] = [
    {
        url: '/products',
        name: 'NAVIGATION.MAIN.products',
        activeClass: 'active',
        languages: ['pl', 'en', 'de', 'sk'],
    },
    {
        url: '/about-us',
        name: 'NAVIGATION.MAIN.about_us',
        activeClass: 'active',
        languages: ['pl', 'en', 'de', 'sk'],
    },
    {
        url: '/our-showroom',
        name: 'NAVIGATION.MAIN.our_showroom',
        activeClass: 'active',
        languages: ['pl', 'en', 'de', 'sk'],
    },
    {
        url: '/configurator',
        name: 'NAVIGATION.MAIN.configurator',
        activeClass: 'active',
        languages: ['pl', 'en', 'de', 'sk'],
    },
    {
        url: '/certificates',
        name: 'NAVIGATION.MAIN.certificates',
        activeClass: 'active',
        languages: ['pl', 'en', 'de', 'sk'],
    },
    {
        url: '/partner-salons',
        name: 'NAVIGATION.MAIN.partner-salons',
        activeClass: 'active',
        languages: ['pl'],
    },
];
